module.exports = __webpack_public_path__ + "img/2. login.6ec40a90.jpg";